import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { THEMES, THEME_COLORS, getLogoPath } from '../components/Constants';

// Import de TOUS les logos column (doit exister dans l'arborescence)
import LogoColumnBlue from '../images/logo_column_blue.png';
import LogoColumnGreen from '../images/logo_column_green.png';
import LogoColumnRed from '../images/logo_column_red.png';
import LogoColumnOrange from '../images/logo_column_orange.png';
import LogoColumnYellow from '../images/logo_column_yellow.png';

// Mapping pour le chargement dynamique du logo
const LOGO_COLUMN_IMAGES = {
  'logo_column_blue.png': LogoColumnBlue,
  'logo_column_green.png': LogoColumnGreen,
  'logo_column_red.png': LogoColumnRed,
  'logo_column_orange.png': LogoColumnOrange,
  'logo_column_yellow.png': LogoColumnYellow,
};

export default function LoadingPage() {
  const { currentTheme } = useTheme();
  const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];

  const logoFileName = getLogoPath(currentTheme, 'column');
  const LogoImage = LOGO_COLUMN_IMAGES[logoFileName] || LogoColumnBlue;

  return (
    <div style={{ ...styles.container, backgroundColor: themeColors.mainBackground }}>
      <div style={styles.loaderContainer}>
        
        {/* Le logo (z-index plus bas que l'animation) */}
        <img
          src={LogoImage}
          alt="Mon Budget App Logo"
          style={styles.logo}
        />

        {/* L'élément orbital (utilise la classe CSS pour l'animation) */}
        <div 
          className="gravitator-orbit" 
          style={{ 
            // Définit la variable CSS --theme-color utilisée par le pseudo-élément ::before
            '--theme-color': themeColors.secondary, 
            // Applique la couleur de la bordure (l'anneau)
            borderColor: themeColors.secondary 
          }}
        >
          {/* ⚠️ Le point gravitant est le pseudo-élément ::before de cette div.
             Il n'y a pas d'élément enfant ici. */}
        </div>

      </div>
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed', 
    top: 0,
    left: 0,
    width: '100vw', 
    height: '100vh', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, 
  },
  loaderContainer: {
    position: 'relative',
    // Conteneur de 300px pour un grand logo
    width: '300px', 
    height: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    // Logo de 200px pour une taille doublée
    width: '200px', 
    height: '200px',
    borderRadius: '50%', 
    zIndex: 5, // Assure que le logo ne cache pas l'animation
    boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)',
  }
};